import { useCallback, useEffect, useState } from "react";
import { pingFlow } from "api";
import { translate } from "@flow-frontend-npm/common";

import Alert from "../Alert/Alert";
import translations from "../../translations.json";

const BROKEN_COUNT_THRESHOLD = 2;
const PING_REQUEST_INTERVAL = 3000;

function ConnectionHealthAlert() {
    const [failedRequestCount, setFailedRequestCount] = useState(0);

    const increaseFailedRequestCount = useCallback(() => {
        setFailedRequestCount((prevState) => prevState + 1);
    }, [setFailedRequestCount]);

    const resetFailedRequestCount = useCallback(() => {
        setFailedRequestCount(0);
    }, [setFailedRequestCount]);

    useEffect(() => {
        const healthCheckInterval = setInterval(() => {
            pingFlow(window.location.href)
                .then((response) => {
                    if (response.data?.message === "__pong__") {
                        resetFailedRequestCount();
                    } else {
                        increaseFailedRequestCount();
                    }
                })
                .catch(() => {
                    increaseFailedRequestCount();
                });
        }, PING_REQUEST_INTERVAL);

        return () => clearInterval(healthCheckInterval);
    }, []);

    if (failedRequestCount >= BROKEN_COUNT_THRESHOLD) {
        return (
            <Alert alert={translate(translations, "muiPage.connectionHealthError")} />
        );
    }

    return null;
}

export default ConnectionHealthAlert;
